
<div class="fitting" perfect>
  <mat-form-field>
    <mat-label>{{ 'WINDOW|Wybierz zestaw profili:' | translate }}</mat-label>
    <mat-select [ngModel]='selectedSetId' (ngModelChange)="changeSet($event)">
      @for (set of resolve.profileSets; track set) {
        <mat-option [value]="set.id">{{ set.name }}</mat-option>
      }
    </mat-select>
  </mat-form-field>
  @for ( type of profileTypes; track  type) {
    @if (haveProfiles(type)) {
      <icc-select-box
        [title]="profileTypesTitle[type]"
        [description]="selectedSet[type].id ? selectedSet[type].name : ('INTERFACE|Brak' | translate)"
        [imageUrl]="type !== 'glazingBeadShape' && '/files/profile/' + (selectedSet[type].img || '')"
        [buttonText]="'INTERFACE|Zmień' | translate"
        (select)="changeProfile(type, selectedSet[type].id)"
      ></icc-select-box>
    }
  }
</div>
<button mat-raised-button color = "primary" (click)="closeModal()" >
  {{ 'INTERFACE|OK' | translate }}
</button>
